import { FC } from 'react';
import cn from 'classnames';
import { ReactComponent as ChevronIcon } from 'images/newIcons/chevron.svg';

import { Theme } from './types';

export interface TreeSelectFieldProps {
  value: string | string[];
  theme?: Theme;
  isOpen: boolean;
  classNames?: { container?: string; text?: string };
  onClick: () => void;
}

export const TreeSelectField: FC<TreeSelectFieldProps> = ({
  value,
  theme = 'dark',
  isOpen,
  classNames,
  onClick,
}) => (
  <div
    className={cn(
      'flex justify-between items-center w-full h-10 px-4 py-3 rounded-[5px] cursor-pointer',
      {
        'bg-dark': theme === 'dark',
        'bg-light': theme === 'light',
      },
      classNames?.container
    )}
    onClick={onClick}
  >
    <span
      className={cn(
        'block tpg-input text-tpg_title truncate',
        classNames?.text
      )}
    >
      {Array.isArray(value) ? value.join(', ') : value}
    </span>
    <ChevronIcon
      className={cn('shrink-0 w-5 h-5 text-tpg_base', isOpen && 'rotate-180')}
    />
  </div>
);
